'use client';

import { c as _c } from "react/compiler-runtime";
import IconUser from '@/components/assets/icon_user.svg';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import VerifiedBadge from '@/components/VerifiedBadge';
import ViverseSkeleton from '@/components/ViverseSkeleton';
import { Link } from '@/i18n/navigation';
import { hasVerifiedCreatorBadge } from '@/lib/cms';
type Creator = {
  name: string;
  username: string;
  avatar: string;
  followers: string;
  following: string;
  description: string;
  profileId: string;
  viverse_pro?: boolean;
  verified_creator?: boolean;
};
type CreatorCardProps = {
  creator: Creator;
};
export default function CreatorCard(t0) {
  const $ = _c(39);
  const {
    creator
  } = t0;
  const t1 = `/profile/${creator.profileId}`;
  let t2;
  if ($[0] !== creator.avatar || $[1] !== creator.name) {
    t2 = <AvatarImage src={creator.avatar} alt={creator.name} />;
    $[0] = creator.avatar;
    $[1] = creator.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== creator.avatar) {
    t3 = <AvatarFallback>{!creator.avatar ? <IconUser className="bg-vive-brand-60 size-full" /> : <ViverseSkeleton className="bg-vive-brand-60 size-full" />}</AvatarFallback>;
    $[3] = creator.avatar;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="1.5xl:min-w-[306px] grid min-w-[80px] place-items-center py-2 md:min-w-[120px] lg:min-w-[200px] lg:py-6"><Avatar className="size-18 lg:size-[100px]">{t2}{t3}</Avatar></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== creator.name) {
    t5 = <span className="truncate">{creator.name}</span>;
    $[8] = creator.name;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== creator) {
    t6 = hasVerifiedCreatorBadge(creator);
    $[10] = creator;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <VerifiedBadge isVerified={t6} />;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <h3 className="text-vive-primary-0 mb-0.5 flex items-center gap-1 text-[14px] leading-[1.3] font-semibold md:gap-2 lg:mb-1 lg:text-[16px]">{t5}{t7}</h3>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== creator.username) {
    t9 = <p className="body-1 text-[12px] leading-[1.3] lg:text-[13px]">{creator.username}</p>;
    $[17] = creator.username;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== creator.followers) {
    t10 = <span className="mr-2"><span className="text-[12px] leading-[1.3] font-semibold">{creator.followers}</span>{" "}followers</span>;
    $[19] = creator.followers;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== creator.following) {
    t11 = <span><span className="text-[12px] leading-[1.3] font-semibold">{creator.following}</span>{" "}following</span>;
    $[21] = creator.following;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <p className="body-1 hidden text-[12px] leading-[1.3] lg:block">{t10}{t11}</p>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== creator.description) {
    t13 = <p className="body-1 line-clamp-2 hidden text-[12px] leading-[1.3] lg:block">{creator.description}</p>;
    $[26] = creator.description;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== t9) {
    t14 = <div className="flex flex-col gap-0.5">{t9}{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t8) {
    t15 = <div className="min-w-0 flex-1">{t8}{t14}</div>;
    $[32] = t14;
    $[33] = t8;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t1 || $[36] !== t15 || $[37] !== t4) {
    t16 = <Link href={t1} className="hover:bg-vive-primary-50/10 group flex cursor-pointer items-center gap-4 p-4 transition-all duration-300 hover:rounded-lg hover:shadow-lg lg:p-0">{t4}{t15}</Link>;
    $[35] = t1;
    $[36] = t15;
    $[37] = t4;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}
export function CreatorCardSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="1.5xl:min-w-[306px] grid min-w-[80px] place-items-center py-2 md:min-w-[120px] lg:min-w-[200px] lg:py-6"><ViverseSkeleton className="size-18 rounded-full lg:size-[100px]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ViverseSkeleton className="mb-1 h-5 w-32" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="group flex cursor-wait items-center gap-4 p-4 transition-all duration-300 lg:p-0">{t0}<div className="min-w-0 flex-1">{t1}<div className="flex flex-col gap-1"><ViverseSkeleton className="h-4 w-24" /><ViverseSkeleton className="hidden h-4 w-40 lg:block" /></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}